export const DATE_TIME_FORMAT = {
  MMM_D_YYYY: 'MMM D, YYYY',
  MM_DD_YYYY: 'MM/DD/YYYY',
  MM_DD_YYYY_hh_mm_A: 'MM/DD/YYYY, hh:mm A',
  YYYY_MM_DD_DASH_hh_mm_ss_A: 'YYYY-MM-DD, hh:mm:ss A',
  YYYY_MM_DD_DASH: 'YYYY-MM-DD',
  h_mm_A: 'h:mm A',
  hh_mm_ss_A: 'hh:mm:ss A',
  MMMM_Do_YYYY: 'MMMM Do YYYY',
  MMMM_DD_YYYY: 'MMMM DD, YYYY',
  MM_DD_YYYY_h_mm_A_GMT_Z: 'MM/DD/YYYY h:mm A [GMT]Z',
  dddd_MMMM_D: 'dddd, MMMM D',
  z: 'z',
  M_D_YYYY: 'M/D/YYYY',
};

export const SERVER_TIMEZONE = '-05:00';
export const DEFAULT_IANA_TIME_ZONE = 'America/New_York';
